import React, { useState, useEffect } from 'react';
import {
  Autocomplete,
  TextField,
  Chip,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import { contentService } from '../../services/api';

const SkillsInput = ({ value = [], onChange, error, helperText, required = false }) => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);

  useEffect(() => {
    loadSkills();
  }, []);

  useEffect(() => {
    // Set selected skills when value prop changes
    if (value && value.length > 0) {
      const selected = skills.filter(skill => 
        value.some(v => (typeof v === 'object' ? v.id : v) === skill.id)
      );
      setSelectedSkills(selected);
    } else {
      setSelectedSkills([]);
    }
  }, [value, skills]);

  const loadSkills = async () => {
    setLoading(true);
    try {
      const response = await contentService.getAllSkills();
      if (response.data.success) {
        setSkills(response.data.skills);
      }
    } catch (error) {
      console.error('Error loading skills:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSkillChange = (event, newValue) => {
    setSelectedSkills(newValue);
    // Pass back the skill IDs to parent component
    const skillIds = newValue.map(skill => skill.id);
    onChange(skillIds);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography 
        variant="body2"
        className="pink-filter"
   
        sx={{ 
          mb: 1, 
          fontWeight: 600,
          color: error ? 'error.main' : 'text.primary'
        }}
      >
        Skills {required && '*'}
      </Typography>
      
      <Autocomplete
        multiple
        id="skills-autocomplete"
        options={skills}
        getOptionLabel={(option) => option.name}
        value={selectedSkills}
        onChange={handleSkillChange}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={selectedSkills.length === 0 ? "Select skills" : ""}
            error={error}
            helperText={helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              variant="outlined"
              label={option.name}
              size="small"
              {...getTagProps({ index })}
              key={option.id}
            />
          ))
        }
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterSelectedOptions
        disableCloseOnSelect
        sx={{
          '& .MuiOutlinedInput-root': {
            minHeight: '48px',
            padding: '4px 8px',
          }
        }}
      />
    </Box>
  );
};

export default SkillsInput;